<template>
  <!--This is the root, aswell as the image surrounding the page, set to take full height of screen-->
  <v-img src="https://valueme-14edb.web.app/matt-lamers-oMWG93b20KU-unsplash.jpg" max-height="100vh">
    <!--This is to position items within-->
    <div style="display:grid; place-items:center; height:100vh;">
      <div>
        <v-snackbar v-model="snackbar" :timeout="3000" :top="true">
          {{ snackbartext }}
          <v-btn color="pink" flat @click="snackbar = false">{{
            $t("Close")
          }}</v-btn>
        </v-snackbar>
        <!--Logo, which leads to the front.             Need custom alert, based if logged in or not-->
        <router-link to="/front" >
          <v-img src="/wenewz_middle_2color.svg" height="100px" contain class="mb-10" />
        </router-link>
        <v-stepper v-model="e1">
          <v-stepper-items :style="{ width: $vuetify.breakpoint.xs ? '100%' : '500px' }">
            <!--Stepper 1 - Will be registation-->
            <v-stepper-content step="1" class="text-center align-self-center">
              <v-row>
                <v-spacer></v-spacer>
                <span style="text-transform: uppercase;" class="title pt-5 pl-12">{{ $t("Register")}}</span>
                <v-col class="pl-12 ml-8">
                  <router-link to="/front" style="text-decoration:none;">
                    <v-btn large icon color="error" outlined>
                      <v-icon large>fas fa-times</v-icon>
                    </v-btn>
                  </router-link>
                </v-col>
              </v-row>
              <v-card flat class="mx-auto pa-5">
                <v-form ref="form"  class="pt-5 pb-6">
                  <v-text-field :label="$t('Email')" v-model="email" required outlined :rules="[rules.emailRequired, rules.validEmail]" />
                  <v-text-field :label="$t('Password')" v-model="password" type="password" required outlined :rules="[rules.passwordRequired]" />
                  <v-text-field :label="$t('Repeat password')" v-model="password2" type="password" required outlined :rules="[rules.required, rules.passwordMatch]" />
                  <v-btn color="primary" @click="e1 = 2" class="mr-3">{{ $t("Continue")}}</v-btn>
                  <v-btn text to="/">{{ $t("Cancel")}}</v-btn>
                </v-form>
                <small v-html="$t('By signing in to WeNewz, you agree to our Terms and Privacy Policy.')"></small>
              </v-card>
              <v-card flat>
                <v-divider></v-divider>
                <div>
                  <span>{{ $t("If you already got an user") }} </span>
                  <br />
                  <span>
                    <router-link to="/login">{{ $t("Click here") }}</router-link>!
                  </span>
                </div>
              </v-card>
            </v-stepper-content>
            <!--Stepper 2 - Register 2-->
            <v-stepper-content step="2" class="text-center align-self-center">
              <v-row>
                <v-spacer></v-spacer>
                <span style="text-transform: uppercase;" class="title pt-5 pl-12">{{ $t("Register")}}</span>
                <v-col class="pl-12 ml-8">
                  <router-link to="/front" style="text-decoration:none;">
                    <v-btn large icon color="error" outlined>
                      <v-icon large>fas fa-times</v-icon>
                    </v-btn>
                  </router-link>
                </v-col>
              </v-row>
              <v-card flat class="mx-auto pa-5">
                <v-form ref="form" @submit.prevent="submitRegister" class="pt-5 pb-6">
                  <v-text-field :label="$t('First Name')" v-model="firstname" required outlined :rules="[rules.firstNameRequired]"/>
                  <v-text-field :label="$t('Last Name')" v-model="lastname" type="text" required outlined :rules="[rules.lastNameRequired]"/>
                  <v-text-field class="pb-4" :label="$t('Display name')" v-model="username"  required :rules="[rules.usernameRequired]" outlined :hint="$t('The name you will be displayed as *')" persistent-hint/>
                  <v-btn color="success" type="submit" class="mr-3">{{$t("Register new user")}}</v-btn>
                  <v-btn color="" text @click="e1 = 1">{{$t("Back")}}</v-btn>
                </v-form>
                <small v-html="$t('By signing in to WeNewz, you agree to our Terms and Privacy Policy.')"></small>
              </v-card>
              <v-card flat>
                <v-divider></v-divider>
                <div>
                  <span>{{ $t("If you already got an user") }} </span>
                  <br />
                  <span>
                    <router-link to="/login">{{ $t("Click here") }}</router-link>!
                  </span>
                </div>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </div>
    </div>
  </v-img>
</template>

<script>
  import messages from "./modules/lang/export";
  export default {
    i18n: { messages },
    data () {
      return {
        e1: 1,
        email: "",
        password: "",
        password2: "",
        username: "",
        firstname: "",
        lastname: "",
        acceptedtos: false,
        snackbar: false,
        snackbartext: "",
        rules: {
          required: value => !!value || this.$t("Required"),
          usernameRequired: value => !!value || this.$t("Display Name Required"),
          emailRequired: value => !!value || this.$t("Email Required"),
          firstNameRequired: value => !!value || this.$t("First Name Required"),
          lastNameRequired: value => !!value || this.$t("Last Name Required"),
          validEmail: value => {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(value) || this.$t("Valid Email Required");
          },
          passwordRequired: value => !!value || this.$t("Password are required"),
          passwordMatch: value => {
            return this.password == value || this.$t("Passwords must match");
          }
        }
      }
    },
    watch:{
      firstname(){
        this.username = this.firstname + "-" + this.lastname
      },
      lastname(){
        this.username = this.firstname + "-" + this.lastname
      }
    },
    methods: {
      generateDisplayName(){
        let displaystring = this.firstname + "-" + this.lastname;
        this.username = displaystring;
      },
      submitRegister() {
        this.snackbartext = this.$t("trying to register");
        this.snackbar = true;
        if (this.$refs.form.validate()) {
          let _userobj = {
            Email: this.email,
            Password: this.password,
            Nickname: this.username,
            FirstName: this.firstname,
            LastName: this.lastname
          };
          this.$store
            .dispatch("register", _userobj)
            .then(resp => {
              this.snackbartext = this.$t("Success");
              this.snackbar = true;
              setTimeout(
                // () => this.$router.push({ name: "nextstep" }),
                () => this.$router.push({ name: "profilesettings" }),
                600
              );
            })
            .catch(err => {
              console.error(err);
              this.snackbartext = this.$t("Couldnt create user");
              this.snackbar = true;
            });
        } else {
          this.snackbartext = this.$t("Couldnt create user");
          this.snackbar = true;
        }
      }
    }
  }
</script>
